import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useToggleState } from 'app/lib/hooks';
import { StatusDialog, DialogType } from 'app/components/composite/StatusDialog';
import { LinkButton } from 'app/components/core/LinkButton';
import { Collapsible } from 'app/components/core/Collapsible';
import * as styles from './ErrorDetailsDialog.css';

export function ErrorDetailsDialog({ errorCode = null, message, detail = null, onClose }) {
    const { t } = useTranslation();
    const [isDetailsCollapsed, toggleDetails] = useToggleState(false);

    const title = useMemo(() => {
        switch (errorCode) {
            case 500:
                return t('components:ErrorDetailsDialog.operationFailed');
            default:
                return t('components:ErrorDetailsDialog.error');
        }
    }, [t, errorCode]);

    return (
        <StatusDialog
            testId="error-details-dialog"
            title={title}
            onClose={onClose}
            submitButtonLabel={t('common:ok')}
            type={DialogType.ERROR}
            width={600}>
            <p>{message}</p>

            {detail && (
                <div className={styles.detailsWrapper}>
                    <LinkButton onClick={toggleDetails}>
                        {isDetailsCollapsed ? 'Show Details' : 'Hide Details'}
                    </LinkButton>
                    <Collapsible onToggle={toggleDetails} collapsed={isDetailsCollapsed}>
                        <div className={styles.details}>{detail}</div>
                    </Collapsible>
                </div>
            )}

            <code>{new Date().toString()}</code>
        </StatusDialog>
    );
}

ErrorDetailsDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    errorCode: PropTypes.number,
    detail: PropTypes.string
};
